<template>
  <el-dialog
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="900px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <span slot="title" class="el-dialog__title">
      <template v-if="Type == 'Create'"> 新增拼单 </template>
      <template v-else> 管理拼单：{{ DialogFormData.code }} </template>
    </span>
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
      label-position="top"
    >
      <AlertTip
        v-if="DialogFormData.status == -1"
        type="danger"
        :title="l('已下架')+'：'"
        :description="DialogFormData.invalid_reason"
      />

      <div class="FormSubTitle">{{l("基本信息")}}</div>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="l('标题')" prop="title">
            <el-input
              v-model="DialogFormData.title"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col key="category_id" :span="12">
          <el-form-item :label="l('品类')" prop="category_id">
            <el-select
              v-model="DialogFormData.category_id"
              :disabled="Type == 'View'"
            >
              <el-option
                v-for="item in $store.state.basicInfo.categoryList_quotation"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="Type == 'View'"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col key="child_category" :span="12">
          <el-form-item
            :label="l('品名')"
            prop="child_category"
            style="position: relative"
          >
            <span slot="label">
              <span>{{l("品名")}}</span>
              <span v-show="Type != 'View'" class="label_tip">
                <span
                  v-show="select_child_category"
                  @click="
                    select_child_category = false;
                    $nextTick(() => $refs.child_category_input.focus());
                  "
                  >{{l("点击输入自定义品名")}}</span
                >
                <span
                  v-show="!select_child_category"
                  @click="select_child_category = true"
                  >{{l("点击使用系统预设品名")}}</span
                >
              </span>
            </span>
            <el-select
              v-if="select_child_category"
              key="child_category_select"
              v-model="DialogFormData.child_category"
              :disabled="Type == 'View'"
              no-data-text="请先选择品类"
            >
              <el-option
                v-for="item in child_categoryList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>

            <el-input
              v-else
              key="child_category_input"
              ref="child_category_input"
              v-model="DialogFormData.child_category"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col key="material" :span="12">
          <el-form-item :label="l('材料')" prop="material" style="position: relative">
            <span slot="label">
              <span>{{l("材料")}}</span>
              <span v-show="Type != 'View'" class="label_tip">
                <span
                  v-show="select_material"
                  @click="
                    select_material = false;
                    $nextTick(() => $refs.material_input.focus());
                  "
                  >{{l("点击输入自定义材料")}}</span
                >
                <span v-show="!select_material" @click="select_material = true"
                  >点击使用系统预设材料</span
                >
              </span>
            </span>
            <el-select
              v-if="select_material"
              key="material_select"
              v-model="DialogFormData.material"
              :disabled="Type == 'View'"
            >
              <el-option
                v-for="item in $store.state.basicInfo.materialList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>

            <el-input
              v-else
              key="material_input"
              ref="material_input"
              v-model="DialogFormData.material"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="l('规格')" prop="specification">
            <el-input
              class="inline-input"
              v-model="DialogFormData.specification"
              placeholder="规格"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="价格" prop="price">
            <el-row>
              <el-col :span="18">
                <el-input
                  v-model="DialogFormData.price"
                  placeholder="价格"
                  :disabled="Type == 'View'"
                ></el-input>
              </el-col>
              <el-col :span="6">
                <el-select
                  v-model="DialogFormData.unit"
                  :disabled="Type == 'View'"
                >
                  <el-option
                    v-for="item in $store.state.basicInfo.unitList"
                    :key="item"
                    :label="'元/' + item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="l('钢厂')" prop="steel_mill">
            <el-input
              v-model="DialogFormData.steel_mill"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <ResourceListUpLoad
            label="商品图片"
            prop="img_array"
            usage="quotation"
            :initResourceUrl.sync="DialogFormData.img_array"
            :disabled="Type == 'View'"
          />
        </el-col>
      </el-row>

      <div class="FormSubTitle">其他信息</div>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="'起拼量(' + DialogFormData.unit + ')'"
            prop="start_amount"
          >
            <el-input-number
              :min="0"
              controls-position="right"
              v-model="DialogFormData.start_amount"
              :disabled="Type == 'View'"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="'拼成目标(' + DialogFormData.unit + ')'"
            prop="amount"
          >
            <el-input-number
              :min="0"
              controls-position="right"
              v-model="DialogFormData.amount"
              :disabled="Type == 'View'"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="l('计重方式')" prop="weight_method">
            <el-radio
              v-for="item in $store.state.basicInfo.weight_methodList"
              :key="item.id"
              v-model="DialogFormData.weight_method"
              :label="item.id"
              :disabled="Type == 'View'"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="提供质保书" prop="have_warranty">
            <el-radio
              v-for="item in $store.state.basicInfo.have_warrantyList"
              :key="item.id"
              v-model="DialogFormData.have_warranty"
              :label="item.id"
              :disabled="Type == 'View'"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="l('截止日期')" prop="expire_time">
            <el-date-picker
              v-model="DialogFormData.expire_time"
              type="date"
              :placeholder="l('选择日期')"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="pickerOptions"
              :clearable="false"
              :disabled="Type == 'View'"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="国家/地区" prop="country">
                <el-select v-model="DialogFormData.country" placeholder="请选择" :disabled="Type == 'View'" @change="DialogFormData.address=['','']" filterable>
                  <el-option v-for="item in $store.state.basicInfo.countryList" :key="item.code" :label="item.cnName+' ('+item.name+')'"
                    :value="item.code">
                    <span style="float: left">{{item.cnName}}（{{ item.name }}）</span>
                    <span style="float: right">
                      <img :src="GetResourceUrl('flags/' + item.code.toLowerCase() + '.png')" style="width:30px;" />
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="城市" prop="address">
                <el-cascader v-if="DialogFormData.country=='CN'"
                  v-model="DialogFormData.address"
                  :options="$store.state.basicInfo.cityList"
                  :props="{
                    expandTrigger: 'hover',
                    label: 'name',
                    value: 'name',
                    children: 'child',
                    emitPath: true,
                  }"
                  clearable
                  :disabled="Type == 'View'"
                ></el-cascader>

                <el-input v-else
                  v-model="DialogFormData.address[0]"
                  placeholder="请输入内容"
                  :disabled="Type == 'View'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="l('补充说明')" prop="description">
            <el-input
              type="textarea"
              :rows="5"
              v-model="DialogFormData.description"
              placeholder="您可以填写关于商品的更多补充说明"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>

      <template
        v-if="
          Type == 'View' && $store.getters.checkPermission('admin_raise.edit')
        "
      >
        <el-button type="warning" @click="Type = 'Edit'">{{l("修 改")}}</el-button>
        <el-button
          type="danger"
          v-show="DialogFormData.status != -1"
          @click="offline"
          >{{l("下架")}}</el-button
        >
        <el-button
          type="success"
          v-show="DialogFormData.status == -1"
          @click="online"
          >{{l("上架")}}</el-button
        >
        <el-button
          type="success"
          v-show="DialogFormData.status == 1"
          @click="complete"
          >结束</el-button
        >
      </template>
      <el-button
        v-if="Type == 'Create' || Type == 'Edit'"
        type="primary"
        @click="submitForm"
        >{{l("保 存")}}</el-button
      >
    </span>
    <RejectDialog ref="rejectDialog" @submitDialog="rejectCallback" />
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditSellerQuotation",
  components: {},
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        id: null,
        code: null,
        status: null,

        title: "",
        category_id: null,
        child_category: null,
        material: "",
        specification: "",
        price: "",
        unit: this.l("吨"),
        weight_method: 1,
        have_warranty: 1,
        img_array: [],
        description: "",
        address: "",
        expire_time: "",
        extra_params: "",
        start_amount: null,
        amount: null,

        country: ""
      },
      dialogRules: {
        title: [{ required: true, message: "请输入标题", trigger: "change" }],
        category_id: [
          {
            required: true,
            type: "number",
            message: "请选择商品品类",
            trigger: "change",
          },
        ],
        child_category: [
          { required: true, message: this.l("请输入") + this.l("品名"), trigger: "change" },
        ],
        material: [
          { required: true, message: this.l("请输入") + this.l("材料"), trigger: "change" },
        ],
        specification: [
          { required: true, message: this.l("请输入") + this.l("规格"), trigger: "change" },
        ],
        price: [{ required: true, message: this.l("请输入") + this.l("价格"), trigger: "change" }],
        steel_mill: [
          { required: true, message: this.l("请输入") + this.l("钢厂"), trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入拼成目标", trigger: "change" },
        ],
        start_amount: [
          { required: true, message: "请输入起拼数", trigger: "change" },
        ],
        address: [
          {
            required: true,
            message: this.l("请选择") + this.l("城市"),
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              if (!value[0]) {
                callback(new Error(this.l("请选择") + this.l("城市")));
              } else {
                callback();
              }
            },
          },
        ],
        img_array: [
          { required: true, message: "请上传商品图片", trigger: "change" },
        ],
        expire_time: [
          { required: true, message: "请选择截止日期", trigger: "change" },
        ],
        country: [
          { required: true, message: this.l("请选择") + this.l("国家/地区"), trigger: "change" },
        ],
      },
      pickerOptions: {
        // disabledDate(time) {
        //   return (
        //     time.getTime() < Date.now() ||
        //     time.getTime() > Date.now() + 3600 * 1000 * 24 * 30
        //   );
        // },
        shortcuts: [
          {
            text: this.l("3天后"),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit("pick", date);
            },
          },
          {
            text: this.l("7天后"),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: this.l("30天后"),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      select_child_category: true,
      select_material: true,
    };
  },
  computed: {
    child_categoryList() {
      var category = this.$store.state.basicInfo.categoryList.find(
        (item) => item.id == this.DialogFormData.category_id
      );
      if (category) {
        return category.child.map((item) => item.name);
      } else {
        return [];
      }
    },
  },
  methods: {
    BeforeShow() {
      return new Promise((resolve, reject) => {
        if (this.Type == "Create") {
          resolve();
        } else if (this.Type == "View") {
          this.axios
            .get(`/api/admin_raise/${this.DialogFormData.code}/`)
            .then((response) => {
              response.img_array = JSON.parse(response.img_array);
              response.address = response.country=="CN"?response.address.split("/"):[response.address];
              response.specification =
                response.specification_amount[0].specification;
              response.price = response.specification_amount[0].price;
              response.unit = response.specification_amount[0].unit;
              this.DialogFormData = response;
              resolve();
            })
            .catch(() => {
              reject();
            });
        }
      });
    },
    AfterShow() {},
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        var img_array = JSON.stringify(this.DialogFormData.img_array);
        var specification_amount = [
          {
            specification: this.DialogFormData.specification,
            price: this.DialogFormData.price,
            unit: this.DialogFormData.unit,
          },
        ];
        var address = this.DialogFormData.country=="CN"?this.DialogFormData.address.join("/"):this.DialogFormData.address[0];

        if (this.Type == "Create") {
          this.axios
            .post(
              `/api/admin_raise/`,
              Object.assign({}, this.DialogFormData, {
                img_array,
                address,
                specification_amount,
              })
            )
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        } else {
          this.axios
            .put(
              `/api/admin_raise/${this.DialogFormData.code}/`,
              Object.assign({}, this.DialogFormData, {
                img_array,
                address,
                specification_amount,
              })
            )
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        }
      });
    },
    complete() {
      this.$confirm(`是否结束【${this.DialogFormData.title}】?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/admin_raise/${this.DialogFormData.code}/complete/`)
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    online() {
      this.$confirm(`是否上架【${this.DialogFormData.title}】?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/admin_raise/${this.DialogFormData.code}/on/`)
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    offline() {
      this.$refs.rejectDialog.Show(
        Object.assign({}, this.DialogFormData, {
          dialogTitle: `下架【${this.DialogFormData.title}】`,
        })
      );
    },
    rejectCallback(item) {
      this.axios
        .put(`/api/admin_raise/${this.DialogFormData.code}/off/`, {
          comment: item.comment,
        })
        .then((data) => {
          this.$emit("submitDialog");
          this.Hide();
        });
    },
  },
};
</script>


<style scoped lang="scss">
/deep/.el-form--label-top .el-form-item__label {
  padding-bottom: 0;
}

.label_tip {
  color: $warningColor;
  position: absolute;
  right: 0;
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
  top: 2px;
}
</style>

